import { ReactNode } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

interface PassengerColumnHeadersProps {
  children: ReactNode;
}

/**
 * Desktop-only column header row for passenger forms.
 */
export default function PassengerColumnHeaders({ children }: PassengerColumnHeadersProps) {
  return (
    <Box sx={{ display: { xs: "none", sm: "none", md: "flex" } }}>
      <Grid container columnSpacing={{ xs: 1 }}>
        {children}
      </Grid>
    </Box>
  );
}
